import React from "react"
import { useSelector } from "react-redux"
import { useField, useFormikContext } from "formik"
import _ from "lodash"

import {
  getDefaultRateCategories,
  getDefaultTiers,
  getFeatures,
} from "@/onboarding/features/product/selectors"
import Pricing from "@/pricing"
import { RateTypeDropdown } from "@/pricing/components/controls/RatesheetPicker"

const RateInputs = ({ name = "ratesheet", readOnly = false, ...props }) => {
  const formCtx = useFormikContext()
  const [field, , helpers] = useField(name)

  const value = _.get(formCtx, `values.${name}`)

  const defaultRateCategories = useSelector(getDefaultRateCategories)
  const features = useSelector(getFeatures)
  const defaultTiers = useSelector(getDefaultTiers)

  const canEditPricingStructure = features.general.product.editPricingStructure

  // A SelectableRatesheet gets its type switcher from RatesheetPicker; a BARE
  // concrete sheet (simple components — venues, restaurants, refreshments —
  // store one unwrapped) historically had no switcher at all. Offer the same
  // dropdown here, replacing the whole value with a fresh sheet of the chosen
  // kind (SHO-TSK-1435: rate types must be switchable wherever structure
  // editing is allowed).
  const bareRatesheet = Boolean(value?.kind) && value.kind !== Pricing.types.SelectableRatesheet

  return (
    <>
      {bareRatesheet && canEditPricingStructure && !readOnly && (
        <RateTypeDropdown
          value={value.kind}
          onChange={(e) =>
            helpers.setValue(
              Pricing.newRatesheet({
                kind: e.target.value,
                defaultRateCategories,
                defaultTiers,
              })
            )
          }
          readOnly={false}
        />
      )}
      <Pricing.Editor
        {...field}
        {...props}
        name={name}
        value={value}
        readOnly={readOnly}
        defaultRateCategories={defaultRateCategories}
        canEditPricingStructure={canEditPricingStructure}
        defaultTiers={defaultTiers}
      />
    </>
  )
}

export default RateInputs
